import React from "react";

import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useDrop } from "react-dnd";
import { makeStyles } from "tss-react/mui";

import EmptyFormIcon from "@/components/Icons/EmptyFormIcon";
import { colors } from "@/theme/overrides/colors";

import FormElementView from "./FormElementView";
import { DragType, FormElementAttributesType } from "./utils/types";
import Section from "../store/Section";

interface Props {
  section: Section;
}

const useStyles = makeStyles()({
  empty: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: colors.light,
    height: "100%",
    border: "2px dotted #B8BEC9",
  },
});

const SectionElements: React.FC<Props> = observer(({ section }) => {
  const { classes } = useStyles();

  const [, drop] = useDrop({
    accept: DragType.COMPONENT,
    drop: (item: FormElementAttributesType) => {
      section.addElementKind(item);
    },
    collect: (monitor) => ({
      dropped: monitor.isOver(),
    }),
  });

  return (
    <div ref={drop}>
      {section.elements.map((e) => (
        <FormElementView key={e.key} element={e} />
      ))}
      {section.elements.length === 0 && (
        <Box className={classes.empty}>
          <EmptyFormIcon
            style={{ height: 200, width: 200, marginTop: "20%" }}
          />
          <Typography variant="h6" color="textSecondary">
            Drag and drop elements from the left panel here.
          </Typography>
        </Box>
      )}
    </div>
  );
});

export default SectionElements;
